import { AlignmentType, BorderStyle, HeadingLevel, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, WidthType } from "docx";

export const OWASPHeading = new Paragraph({
    spacing: { before: 150, after: 100 },
    children: [new TextRun({
        text: "8.  Benchmarking with OWASP TOP 10",
        color: "FF0000",
        bold: true
    })],
    heading: HeadingLevel.HEADING_2,
})

export const barchartText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The below chart depicts the number of discovered vulnerabilities mapped to OWASP 2025 testing category.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})


export const OWASPText1 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 650, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "OWASP has rated the Top Ten Vulnerabilities found in Web applications worldwide. OWASP Web Top Ten Vulnerabilities details can be found at below link.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const OWASPText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "https://owasp.org/Top10/2025/",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export const owasptableText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The table below shows how web application compares with respect to the OWASP 2025 Top 10 list.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})

export function top10ListTable(brokenAccess, cryptoFailures, injection, inseureDesign, security, outdatedComp, identification, softwareFailures, securityFailures, ssrf) {
    console.log(brokenAccess)
    console.log(cryptoFailures)
    console.log(injection)
    console.log(inseureDesign)
    console.log(security)
    console.log(outdatedComp)
    console.log(identification)
    console.log(softwareFailures)
    console.log(securityFailures)
    console.log(ssrf)

    return new Table({
        width: { size: 90, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        spacing: { before: 1200 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 280, after: 280 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "#",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "003366" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 62, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 280, after: 280 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "VULNERABILITIES",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID, color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        width: { size: 28, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 280, after: 280 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "STATUS",
                                        font: "Calibri",
                                        size: 22,
                                        color: "ffffff",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: {
                            type: ShadingType.SOLID, color: "003366",
                        },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Broken Access Control",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: brokenAccess === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: brokenAccess === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "2",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Cryptographic Failures ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: cryptoFailures === 0 ? 'Protected' : 'UnProtected',

                                        font: "Calibri",
                                        size: 22,
                                        color: cryptoFailures === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "3",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Injection ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: injection === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: injection === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "4",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Insecure Design ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: inseureDesign === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: inseureDesign === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "5",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Security Misconfiguration  ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: security === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: security === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "6",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Vulnerable and Outdated Components ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: outdatedComp === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: outdatedComp === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "7",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Identification and Authentication Failures",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: identification === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: identification === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "8",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Software and Data Integrity Failures",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: softwareFailures === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: softwareFailures === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "9",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Security Logging and Monitoring Failures ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: securityFailures === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: securityFailures === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "10",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.LEFT,
                                indent: { left: 100 },
                                children: [
                                    new TextRun({
                                        text: "Server-Side Request Forgery (SSRF) ",
                                        font: "Calibri",
                                        size: 22,
                                        color: '000000',
                                        italics: false,
                                        bold: true,
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),

                    new TableCell({
                        children: [
                            new Paragraph({
                                spacing: { before: 180, after: 180 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: ssrf === 0 ? 'Protected' : 'UnProtected',
                                        font: "Calibri",
                                        size: 22,
                                        color: ssrf === 0 ? '00B050' : 'ff0000',
                                        bold: true,
                                        allCaps: true,
                                        italics: false
                                    }),
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D9D9D9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        },
                    }),
                ]
            }),
        ]
    })
}